export const THEME_STORAGE_KEY = 'kinetic-theme';

export const DEFAULT_THEME = {
  accent: '#A29BFE',
  accentStrong: '#7868E6',
  surface: '#181C25',
  panel: '#1F242F',
  inset: '#11141B'
};

export const THEME_FIELDS = [
{
  key: 'accent',
  label: 'Main color',
  description: 'Buttons, highlights, and focus rings. A deeper shade is derived automatically.'
}];


export const BACKGROUND_FIELDS = [
{
  key: 'surface',
  label: 'Surface background',
  description: 'Main window background.'
},
{
  key: 'panel',
  label: 'Panel background',
  description: 'Panels and cards.'
},
{
  key: 'inset',
  label: 'Inset background',
  description: 'Inputs and list interiors.'
}];


export const normalizeHex = (value) => {
  if (!value || typeof value !== 'string') return null;
  const match = value.match(/^#?([0-9A-Fa-f]{6})$/);
  return match ? `#${match[1].toUpperCase()}` : null;
};

export const hexToRgb = (hex) => {
  const normalized = normalizeHex(hex);
  if (!normalized) return null;
  const r = parseInt(normalized.slice(1, 3), 16);
  const g = parseInt(normalized.slice(3, 5), 16);
  const b = parseInt(normalized.slice(5, 7), 16);
  return { r, g, b };
};

export const deriveAccentStrong = (hex) => {
  const rgb = hexToRgb(hex);
  if (!rgb) return DEFAULT_THEME.accentStrong;
  const { r, g, b } = rgb;

  const shade = (segment) => Math.max(0, Math.floor(segment * 0.7));
  const toHex = (num) => num.toString(16).padStart(2, '0').toUpperCase();
  return `#${toHex(shade(r))}${toHex(shade(g))}${toHex(shade(b))}`;
};

export const normalizeTheme = (value) => {
  if (!value || typeof value !== 'object') return { ...DEFAULT_THEME };
  const out = { ...DEFAULT_THEME };
  for (const key of Object.keys(DEFAULT_THEME)) {
    const valid = normalizeHex(value[key]);
    if (valid) out[key] = valid;
  }

  if (
  out.accent !== DEFAULT_THEME.accent &&
  out.accentStrong === DEFAULT_THEME.accentStrong)
  {
    out.accentStrong = deriveAccentStrong(out.accent);
  }
  return out;
};

export const loadTheme = () => {
  try {
    const raw = localStorage.getItem(THEME_STORAGE_KEY);
    if (!raw) return { ...DEFAULT_THEME };
    return normalizeTheme(JSON.parse(raw));
  } catch {
    return { ...DEFAULT_THEME };
  }
};

export const saveTheme = (theme) => {
  localStorage.setItem(THEME_STORAGE_KEY, JSON.stringify(theme));
};

export const applyTheme = (theme) => {
  const root = document.documentElement;
  root.style.setProperty('--accent', theme.accent);
  root.style.setProperty('--accent-strong', theme.accentStrong);
  root.style.setProperty('--bg-surface', theme.surface);
  root.style.setProperty('--bg-panel', theme.panel);
  root.style.setProperty('--bg-inset', theme.inset);


  const setRgb = (name, hex) => {
    const rgb = hexToRgb(hex);
    if (rgb) {
      root.style.setProperty(name, `${rgb.r} ${rgb.g} ${rgb.b}`);
    }
  };
  setRgb('--accent-rgb', theme.accent);
  setRgb('--bg-surface-rgb', theme.surface);
  setRgb('--bg-panel-rgb', theme.panel);
  setRgb('--bg-inset-rgb', theme.inset);
};